import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TestLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleTestLogin = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${API}/test-login`, {
        email: 'deisycp1424@gmail.com'
      }, { 
        withCredentials: false,
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.data.success) {
        toast.success('¡Acceso concedido! Redirigiendo...');
        // Force full page reload to refresh auth state
        setTimeout(() => {
          window.location.replace('/dashboard');
        }, 500);
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Error al acceder: ' + (error.response?.data?.detail || error.message));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 via-pink-50 to-orange-50 flex items-center justify-center px-6">
      <Card className="max-w-md w-full">
        <CardHeader>
          <CardTitle className="text-2xl text-center">Acceso de Prueba - DeisyCFit</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center text-gray-600">
            <p className="mb-2">Acceso especial para:</p>
            <p className="font-bold text-purple-600">deisycp1424@gmail.com</p>
          </div>

          <Button 
            className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:opacity-90" 
            size="lg"
            onClick={handleTestLogin}
            disabled={loading}
          >
            {loading ? 'Accediendo...' : 'Acceder a la Plataforma'}
          </Button>

          <p className="text-xs text-gray-500 text-center">
            Este es un acceso directo para pruebas. Tendrás acceso completo a todas las funcionalidades.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default TestLogin;
